import OverlayTrigger from '@rio-cloud/rio-uikit/components/overlay/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/components/tooltip/Tooltip';
import type { ReactNode } from 'react';
import { FormattedDate } from 'react-intl';

interface TimeTooltipProps {
    value: string | undefined;
    children: ReactNode;
    timeStyle?: 'short' | 'medium' | 'long' | 'full';
    dateStyle?: 'short' | 'medium' | 'long' | 'full';
}

export const TimeTooltip = ({ value, children, timeStyle = 'short', dateStyle = 'short' }: TimeTooltipProps) =>
    value ? (
        <OverlayTrigger
            overlay={
                <Tooltip>
                    <FormattedDate value={value} timeStyle={timeStyle} dateStyle={dateStyle} />
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    ) : (
        children
    );
